module.exports = {"id":"170320","name":"Lorenzo De Silvestri","rating":"76","photo":"./data/images/photos/1/170320.png","club":{"name":"Torino","logo":"./data/images/clubs/Torino.png"},"positions":["DD","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LorenzoDeSilvestri0.json
// module id = 2531
// module chunks = 0